module.exports = __webpack_public_path__ + "img/8280808ab0c152b9d003044e5243ff2b.svg";